import { VODCSSModules } from 'shared/utils/wix-connect';

import styles from './middle-buttons.styl';
import { GenericButton } from 'shared/components/button/button';
import { RoundedIcon } from 'shared/components/icon/icon';


export const PlayButton = VODCSSModules(styles)(
  ({ onClick, children }) => (
    <GenericButton renderAsLink
                   styleName="play"
                   onClick={onClick}
                   className="qa-widget-overlay-play-button">
      <RoundedIcon styleName="icon play-icon"
                   name="arrow-right-filled" />
      <span styleName="text">
        {children}
      </span>
    </GenericButton>
  )
);

export const PurchaseButton = VODCSSModules(styles)(
  ({ onClick, children }) => (
    <GenericButton renderAsLink
                   styleName="purchase"
                   onClick={onClick}
                   className="qa-widget-overlay-play-button">
      <span styleName="text">
        {children}
      </span>
    </GenericButton>
  )
);



// WEBPACK FOOTER //
// ./src/widget/components/player-overlay/mobile/three-rows-widget/buttons/middle-buttons.js